import { render, staticRenderFns } from "./LegalStatusTaskStatus.vue?vue&type=template&id=1a4d46e0&"
import script from "./LegalStatusTaskStatus.vue?vue&type=script&lang=js&"
export * from "./LegalStatusTaskStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../vue/vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports